function parseHex(hex) {
  const c = parseInt((hex || "#000000").replace("#", ""), 16);
  return [(c >> 16) & 0xff, (c >> 8) & 0xff, c & 0xff];
}

function toHex(r, g, b) {
  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
}

function luminance(hex) {
  const [r, g, b] = parseHex(hex).map((v) => v / 255);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function lighten(hex, amt) {
  const [r, g, b] = parseHex(hex);
  return toHex(
    Math.min(255, r + Math.round(amt * 255)),
    Math.min(255, g + Math.round(amt * 255)),
    Math.min(255, b + Math.round(amt * 255)),
  );
}

export function darken(hex, amt) {
  const [r, g, b] = parseHex(hex);
  return toHex(
    Math.max(0, r - Math.round(amt * 255)),
    Math.max(0, g - Math.round(amt * 255)),
    Math.max(0, b - Math.round(amt * 255)),
  );
}

export function buildTheme(bg, accent) {
  const isLight = luminance(bg) > 0.5;
  const shift = isLight ? darken : lighten;

  return {
    bg,
    accent,
    isLight,
    accentBg: `${accent}14`,
    surface: isLight ? shift(bg, 0.05) : shift(bg, 0.03),
    surface2: isLight ? shift(bg, 0.09) : shift(bg, 0.06),
    surface3: isLight ? shift(bg, 0.14) : shift(bg, 0.1),
    border: shift(bg, 0.14),
    effort: "#FF8C42",
    effortBg: "rgba(255,140,66,0.10)",
    text: isLight ? "#1A1D23" : "#F2F4F7",
    muted: isLight ? "#6B7280" : "#7A8494",
    mutedDark: isLight ? "#4B5563" : "#555555",
    mutedLight: isLight ? "#9CA3AF" : "#aaaaaa",
    /** Fond carte dense (modales, tuiles finance) — repère Lovable. */
    card: isLight ? shift(bg, 0.06) : "#0D0F14",
    statusTemplate: "#F59E0B",
    sectionFinisher: "#a855f7",
    sectionWarmup: "#22c55e",
    sectionStrength: "#3b82f6",
    danger: "#FF5252",
    warning: isLight ? "#D97706" : "#FFB547",
    success: "#34D399", // emerald-400 — sémantique "tout va bien", distinct de accent (lime)
    info: isLight ? "#2563EB" : "#5BC8F5",
  };
}

export function getReadableColor(hex) {
  return luminance(hex) > 0.5 ? "#050509" : "#F9FAFB";
}
